// extracted by mini-css-extract-plugin
export default {"section":"MiceHighlights_section__ajmL2","heading":"MiceHighlights_heading__ElICa","cardsGrid":"MiceHighlights_cardsGrid__z4e2C"};